import { render, staticRenderFns } from "./ProjectDialog.vue?vue&type=template&id=ee5c0d7e&scoped=true&"
import script from "./ProjectDialog.vue?vue&type=script&lang=js&"
export * from "./ProjectDialog.vue?vue&type=script&lang=js&"
import style0 from "./ProjectDialog.vue?vue&type=style&index=0&id=ee5c0d7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee5c0d7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee5c0d7e')) {
      api.createRecord('ee5c0d7e', component.options)
    } else {
      api.reload('ee5c0d7e', component.options)
    }
    module.hot.accept("./ProjectDialog.vue?vue&type=template&id=ee5c0d7e&scoped=true&", function () {
      api.rerender('ee5c0d7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProjectDialog.vue"
export default component.exports